module.exports = __webpack_public_path__ + "static/petkovic-gray-c60e5b2b0a07e64997ac9ae70e91a75e.png";